export type OfflineCacheStrategy = "network-first" | "cache-first"

export type OfflineCachePolicy = {
  cacheName: string
  strategy: OfflineCacheStrategy
  storage: "indexeddb" | "filesystem-cache"
  maxEntries: number
  maxAgeSeconds: number
  networkTimeoutSeconds?: number
  cacheableContentTypes?: string[]
  // Strip the entire query string when computing the cache key. Needed for
  // Mapbox tiles/style requests, where mapbox-gl appends a per-session `sku`
  // param the prefetcher never sees, so keyed-by-full-URL entries never match.
  stripQueryFromCacheKey?: boolean
}

export const OFFLINE_CACHE_POLICIES = {
  alaApi: {
    cacheName: "ala-api",
    strategy: "network-first",
    storage: "indexeddb",
    maxEntries: 500,
    maxAgeSeconds: 60 * 60 * 24 * 7,
    networkTimeoutSeconds: 5,
    cacheableContentTypes: ["application/json"],
  },
  alaRemoteImages: {
    cacheName: "ala-remote-images",
    strategy: "cache-first",
    storage: "filesystem-cache",
    maxEntries: 500,
    maxAgeSeconds: 60 * 60 * 24 * 7,
    cacheableContentTypes: ["image/"],
  },
  mapboxTiles: {
    cacheName: "mapbox-tiles",
    strategy: "cache-first",
    storage: "filesystem-cache",
    maxEntries: 12000,
    maxAgeSeconds: 60 * 60 * 24 * 180,
    stripQueryFromCacheKey: true,
  },
} satisfies Record<string, OfflineCachePolicy>
